import Template1NewsSlidePreview from "./template-1/news-slide/NewsSlidePreview";
import Template1StylingSettings from "./template-1/StylingSettings";
import Template1OpeningSlidePreview from "./template-1/opening-slide/OpeningSlidePreview";
import MotorsportSlidePreview from "./motorsport/SlidePreview";
import ScmpStylingSettings from "./scmp/StylingSettings";
import ScmpNewsSlidePreview from "./scmp/news-slide/NewsSlidePreview";
import {
  TEMPLATE1_DEFAULT_STYLE_SETTINGS,
  template1DataConverter,
} from "./template-1";
import {
  MOTORSPORT_DEFAULT_STYLE_SETTINGS,
  motorsportDataConverter,
} from "./motorsport";
import {
  SCMP_DEFAULT_STYLE_SETTINGS,
  scmpDataConverter,
} from "./scmp";
import DovizStylingSettings from "./doviz/StylingSettings";
import DovizSlidePreview from "./doviz/SlidePreview";
import { dovizDataConverter } from "./doviz";

const renderTemplateStylingSettings = (
  templateName,
  styleSettings,
  handleStyleChange
) => {
  switch (templateName) {
    case "template-1":
      return (
        <Template1StylingSettings
          styleSettings={styleSettings}
          handleStyleChange={handleStyleChange}
        />
      );
    case "scmp":
      return (
        <ScmpStylingSettings
          styleSettings={styleSettings}
          handleStyleChange={handleStyleChange}
        />
      );
    case "doviz":
      return (
        <DovizStylingSettings
          styleSettings={styleSettings}
          handleStyleChange={handleStyleChange}
        />
      );
    default:
      return null;
  }
};

const renderTemplateOpeningSlidePreview = ({
  template,
  logo,
  backgroundColor,
}) => {
  switch (template) {
    case "template-1":
      return (
        <Template1OpeningSlidePreview
          logo={logo}
          backgroundColor={backgroundColor}
        />
      );
    default:
      return null;
  }
};
const renderTemplateSlideItemPreview = ({ template, news, styleSettings }) => {
  switch (template) {
    case "template-1":
      return (
        <Template1NewsSlidePreview
          news={{
            title: news?.title?.text ?? news?.title,
            category: news?.category?.text ?? news?.category,
            subTitle: news?.subTitle?.text ?? news?.subTitle,
            image: news?.imageUrl || news?.image,
          }}
          styleSettings={styleSettings}
        />
      );
    case "motorsport":
      return (
        <MotorsportSlidePreview
          news={{
            category: news?.category?.text ?? news?.category,
            title: news?.title?.text ?? news?.title,
            image: news?.imageUrl || news?.image,
          }}
        />
      );
    case "scmp":
      return (
        <ScmpNewsSlidePreview
          news={{
            title: news?.title?.text ?? news?.title,
            category: news?.category?.text ?? news?.category,
            image: news?.imageUrl || news?.image,
            voiceText: news?.voiceText ?? "",
          }}
          styleSettings={styleSettings}
        />
      );
    case "doviz":
      return (
        <DovizSlidePreview
          news={{
            title: news?.title?.text ?? news?.title,
            category: news?.category?.text ?? news?.category,
            image: news?.imageUrl || news?.image,
          }}
        />
      );
    default:
      return null;
  }
};

const templateDataConverter = ({
  templateName,
  styleSettings,
  selectedNews,
  newsList,
}) => {
  switch (templateName) {
    case "template-1":
      return template1DataConverter({ styleSettings, selectedNews, newsList });
    case "motorsport":
      return motorsportDataConverter({ styleSettings, selectedNews, newsList });
    case "scmp":
      return scmpDataConverter({ styleSettings, selectedNews, newsList });
    case "doviz":
      return dovizDataConverter({ selectedNews, newsList });
    default:
      return null;
  }
};

const templateDefaultStyleSettings = (templateName) => {
  switch (templateName) {
    case "template-1":
      return TEMPLATE1_DEFAULT_STYLE_SETTINGS;
    case "motorsport":
      return MOTORSPORT_DEFAULT_STYLE_SETTINGS;
    case "scmp":
      return SCMP_DEFAULT_STYLE_SETTINGS;
    default:
      return null;
  }
};

export {
  renderTemplateStylingSettings,
  renderTemplateSlideItemPreview,
  renderTemplateOpeningSlidePreview,
  templateDataConverter,
  templateDefaultStyleSettings,
};
